//*componentes-utiles
import GeneraSemaforo from "../../../componentes/generaSemaforo/GeneraSemaforo";

//*clases
//import "../../../componentes/generaSemaforo/style.css";

//*componente
export default function Ejemplo() {
  //let estado = "rojo";
  return (
    <div>
      <h1>Ejemplo de generación de un Semáforo</h1>
      <GeneraSemaforo estado={"r"} />
      <GeneraSemaforo estado={"a"} />
      <GeneraSemaforo estado={"v"} />
    </div>
  );
}
